import React, { useState, useEffect, useRef } from "react";
import Context from "../Context";
import blogFetch from "../../axios/config";
import toast from "react-hot-toast";
import { fetchHourByFurnaceCached } from "../../utils/hourCache";

export default function ContextProvider({ children }) {
  const [loadingFullScreen, setLoadingFullScreen] = useState(false);
  // Language
  const [selectedCountry, setSelectedCountry] = useState({
    code: "BR",
    name: "Brazil",
  });
  // Config sideBar
  const getKeyDisplayMenu = localStorage.getItem("sideBar");
  const [displayMenu, setDisplayMenu] = useState(
    getKeyDisplayMenu ? getKeyDisplayMenu : "",
  );
  const [displayIcon, setDisplayIcon] = useState("");
  const urlCode = window.location.href.split("dashboard/")[1];
  const userSector = JSON.parse(localStorage.getItem("user"));
  // Config Setor Inicial
  const [selectedValueSector, setSelectedValueSector] = useState({
    stR_description: urlCode
      ? urlCode
      : userSector?.sector.stR_description
        ? userSector?.sector.stR_description
        : "01CORTE",
    stR_SAPCode: userSector?.sector.stR_SAPCode
      ? userSector?.sector.stR_SAPCode
      : "01CORTE",
  });
  // Config Ficha
  const [loadingFicha, setLoadingFicha] = useState(false);
  // Sequência de requisições da Ficha: descarta respostas obsoletas quando o
  // usuário troca de aba antes da resposta anterior chegar (evita "travar na tela antiga").
  const fichaReqSeq = useRef(0);
  const [loadingIndustryPartsTable, setIndustryPartsTable] = useState(false);
  const [loadingWagonTable, setLoadingWagonTable] = useState(false);
  const [partFlowObj, setPartFlowObj] = useState({});
  const [idStep, setIdStep] = useState(0);
  const [infoPiece, setInfoPiece] = useState("");
  // Config Info
  const [pecasObj, setPecasObj] = useState();
  const [rastreabilidadeObj, setRastreabilidadeObj] = useState();
  const [glassLotObj, setGlassLotObj] = useState();
  const [moldesObj, setmoldesObj] = useState();
  const [toolMasurementsObj, setToolMasurementsObj] = useState([]);
  const [materialFormObj, setMaterialFormObj] = useState([]);
  const [codeMaterials, setCodeMaterials] = useState();
  const [moldsSector, setMoldsSector] = useState([]);
  // Loading por seção do INFO: cada accordion libera assim que o seu request termina.
  const [infoLoading, setInfoLoading] = useState({
    pecas: false,
    rastreabilidade: false,
    glassLot: false,
    componentes: false,
    moldes: false,
    tools: false,
  });
  const setInfoSectionLoading = (key, value) =>
    setInfoLoading((prev) => ({ ...prev, [key]: value }));
  // Config Racks
  const [bufferObj, setBufferObj] = useState({});
  //Forno
  const [fornoObj, setFornoObj] = useState({});
  // Pedido
  const [SalesOrdersObj, setSalesOrdersObj] = useState({});
  // Imagem
  const [showmodalIMG, setShowmodalIMG] = useState(false);
  // Pendência
  const [toolTipText, setToolTipText] = useState("Vazio");
  const [statusPendencia, setStatusPendencia] = useState(false);
  // Modal Ficha
  const [showModalFicha, setShowModalFicha] = useState(false);

  // Ficha
  const [code, setCode] = useState("");
  const [parts, setParts] = useState([]);
  const [originalParts, setOriginalParts] = useState([]);
  const [wagon, setWagon] = useState([]);
  const [selectedFurnace, setSelectedFurnace] = useState();
  const [furnace, setFurnace] = useState([]);
  const [partsByFurnace, setPartsByFurnace] = useState([]);
  const [confirmedWagon, setConfirmedWagon] = useState([]);
  const [selectedWagon, setSelectedWagon] = useState();
  const [similarParts, setSimilarParts] = useState();
  const [disableButton, setDisableButton] = useState(false);
  const [moldesEstoque, setMoldesEstoque] = useState([]);
  const [searchWagon, setSearchWagon] = useState("");

  const [itemsPriority, setItemsPriority] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState("");
  const [saga_Componentes, setSaga_Componentes] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [modelModal, setModelModal] = useState();

  useEffect(() => {
    localStorage.setItem("sideBar", displayMenu);
  }, [displayMenu]);

  const getStatusSideBar = () => {
    return displayMenu ? "navbar-is-not-visible" : "";
  };

  const getSector = async () => {
    try {
      const { data } = await blogFetch.get("/sector");
      return data;
    } catch (error) {
      console.error(error);
    }
  };

  // Fluxo
  const getPartFlow = async (params) => {
    const myReq = ++fichaReqSeq.current;
    try {
      setLoadingFicha(true);
      const { data } = await blogFetch.get(
        `/SAGAViewOrdemApontamentos/${params.ordem}`,
      );
      if (myReq !== fichaReqSeq.current) return;
      setPartFlowObj(data);
    } catch (error) {
      console.error(error);
    } finally {
      if (myReq === fichaReqSeq.current) setLoadingFicha(false);
    }
  };

  const toArray = (data) => (Array.isArray(data) ? data : []);

  const getPecas = async (params, reqId) => {
    try {
      const { data } = await blogFetch.get(`/ConsumpitonCost/${params.ordem}`);
      if (reqId != null && reqId !== fichaReqSeq.current) return;
      setPecasObj(toArray(data));
    } catch (error) {
      console.error(error);
      if (reqId == null || reqId === fichaReqSeq.current) setPecasObj([]);
    } finally {
      if (reqId == null || reqId === fichaReqSeq.current) setInfoSectionLoading("pecas", false);
    }
  };

  const getRastreabilidade = async (params, reqId) => {
    try {
      const { data } = await blogFetch.get(`/SAGAViewRastreabilidadeOrdem/${params.ordem}`);
      if (reqId != null && reqId !== fichaReqSeq.current) return;
      setRastreabilidadeObj(toArray(data));
    } catch (error) {
      console.error(error);
      if (reqId == null || reqId === fichaReqSeq.current) setRastreabilidadeObj([]);
    } finally {
      if (reqId == null || reqId === fichaReqSeq.current) setInfoSectionLoading("rastreabilidade", false);
    }
  };

  const getGlassLot = async (params, reqId) => {
    try {
      const { data } = await blogFetch.get(`/GlassLot/${params.ordem}`);
      if (reqId != null && reqId !== fichaReqSeq.current) return;
      setGlassLotObj(toArray(data));
    } catch (error) {
      console.error(error);
      if (reqId == null || reqId === fichaReqSeq.current) setGlassLotObj([]);
    } finally {
      if (reqId == null || reqId === fichaReqSeq.current) setInfoSectionLoading("glassLot", false);
    }
  };

  const getGlassComponent = async (params, reqId) => {
    try {
      const { data } = await blogFetch.get(
        `/GlassLot/componente/${params.ordem}`,
      );
      if (reqId != null && reqId !== fichaReqSeq.current) return;
      setSaga_Componentes(toArray(data));
    } catch (error) {
      console.error(error);
      if (reqId == null || reqId === fichaReqSeq.current) setSaga_Componentes([]);
    } finally {
      if (reqId == null || reqId === fichaReqSeq.current) setInfoSectionLoading("componentes", false);
    }
  };

  const getMoldes = async (params, reqId) => {
    try {
      const { data } = await blogFetch.get(
        `/iSAGAViewMoldesGalgas/${params.ordem}`,
      );
      if (reqId != null && reqId !== fichaReqSeq.current) return;
      setmoldesObj(toArray(data));
    } catch (error) {
      console.error(error);
      if (reqId == null || reqId === fichaReqSeq.current) setmoldesObj([]);
    } finally {
      if (reqId == null || reqId === fichaReqSeq.current) setInfoSectionLoading("moldes", false);
    }
  };

  const getToolMasurementsObj = async (code, reqId) => {
    const isCurrent = () => reqId == null || reqId === fichaReqSeq.current;
    try {
      const codeToUse = code != null ? code : codeMaterials;
      if (!codeToUse) {
        if (isCurrent()) setToolMasurementsObj([]);
        return [];
      }
      const { data } = await blogFetch.get(`/ToolMasurements/${codeToUse}`);
      if (!isCurrent()) return;
      setToolMasurementsObj(toArray(data));
      return data;
    } catch (error) {
      console.error(error);
      if (isCurrent()) setToolMasurementsObj([]);
      return [];
    }
  };


  const getMaterialForm = async (params, reqId) => {
    const isTopLevel = reqId == null;
    const myReq = isTopLevel ? ++fichaReqSeq.current : reqId;
    try {
      if (isTopLevel) setLoadingFicha(true);
      const { data } = await blogFetch.get(`/MaterialReserve/${params.ordem}`);
      const materiais = toArray(data);
      const code = materiais
        .map((eachObj) => eachObj.COD_MATERIAL)
        .filter(Boolean)
        .join(";");
      if (myReq !== fichaReqSeq.current) return code;
      setMaterialFormObj(materiais);
      setCodeMaterials(code);
      return code;
    } catch (error) {
      console.error(error);

      if (myReq === fichaReqSeq.current) {
        setMaterialFormObj([]);
        setCodeMaterials("");
      }
      return "";
    } finally {
      if (isTopLevel && myReq === fichaReqSeq.current) setLoadingFicha(false);
    }
  };
  // Get Info - End

  // Info
  const handleInfo = async (data) => {
    const myReq = ++fichaReqSeq.current;
    // O INFO não usa o loading global: cada accordion mostra o próprio spinner.
    // Limpa um loadingFicha de outra aba cujo finally será ignorado pelo guard.
    setLoadingFicha(false);
    setInfoLoading({
      pecas: true,
      rastreabilidade: true,
      glassLot: true,
      componentes: true,
      moldes: true,
      tools: true,
    });
    try {
      await Promise.all([
        getPecas(data, myReq),
        getRastreabilidade(data, myReq),
        getGlassLot(data, myReq),
        getGlassComponent(data, myReq),
        getMoldes(data, myReq),
        // ToolMasurements depende do código retornado por getMaterialForm,
        // por isso é encadeado (as demais seguem em paralelo).
        getMaterialForm(data, myReq)
          .then((code) => getToolMasurementsObj(code, myReq))
          .finally(() => {
            if (myReq === fichaReqSeq.current) setInfoSectionLoading("tools", false);
          }),
      ]);
    } catch (error) {
      console.error(error);
    }
  };

  // Racks
  const getBuffers = async (params) => {
    const myReq = ++fichaReqSeq.current;
    try {
      setLoadingFicha(true);
      const { data } = await blogFetch.get(`/Buffer/${params.ordem}`);
      if (myReq !== fichaReqSeq.current) return;
      setBufferObj(data);
    } catch (error) {
      console.error(error);
    } finally {
      if (myReq === fichaReqSeq.current) setLoadingFicha(false);
    }
  };

  // Pedido
  const getSalesOrdersBI = async (params) => {
    const myReq = ++fichaReqSeq.current;
    try {
      setLoadingFicha(true);
      const { data } = await blogFetch.get(
        `/ISAGAViewInfoPedidos/${params.pedido}`,
      );
      if (myReq !== fichaReqSeq.current) return;
      setSalesOrdersObj(data);
    } catch (error) {
      console.error(error);
    } finally {
      if (myReq === fichaReqSeq.current) setLoadingFicha(false);
    }
  };

  const getFicha = async (order) => {
    try {
      const response = await blogFetch.get(`/SAGAViewFichaCabecalho/${order}`);
      return response.data[0];
    } catch (error) {
      console.error(error);
      return null;
    }
  };

  const getMolds = async () => {
    try {
      setLoadingFicha(true);
      setLoading(true);
      const { data } = await blogFetch.get(`/ISAGA_VagoesFornosPecas/molds`);
      return data;
    } catch (error) {
      console.error(error);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const getChangeMolds = async (moldeKey) => {
    try {
      setLoadingFicha(true);
      const { data } = await blogFetch.get(
        `/ISAGA_VagoesFornosPecas/getChangeMolds/` + moldeKey,
      );
      return data;
    } catch (error) {
      console.error(error);
    }
  };

  const findMoldByKey = (moldeKey) =>
    moldsSector
      .flatMap(({ moldsWagon }) => moldsWagon ?? [])
      .find(({ mold }) => String(mold.molde_Key) === String(moldeKey))?.mold;

  const putMold = async (params) => {
    // Molde que já cumpriu todas as passagens só volta a rodar após manutenção,
    // então nenhuma reserva é aceita: nem pelo scanner, nem pelo botão confirmar.
    const mold = findMoldByKey(params.molde_Key);
    if (
      params.status === "RESERVADO" &&
      mold?.molde_QtdPassagensMAX &&
      mold.molde_QtdPassagens >= mold.molde_QtdPassagensMAX
    ) {
      toast.error(
        `O molde ${mold.molde_Lote} atingiu o limite de passagens (${mold.molde_QtdPassagens}/${mold.molde_QtdPassagensMAX}) e não pode ser reservado. É necessária a manutenção do molde.`,
        { duration: 5000 },
      );
      return;
    }

    try {
      setLoadingFullScreen(true);

      const payload = {
        vagao_Key: params.vagao_Key,
        molde_Key: params.molde_Key,
        ordem_Serial: params.ordem_Serial,
        status: params.status,
      };

      await blogFetch.put(`/ISAGA_Moldes/fornoPecas`, payload);

      const objModal = {
        quantidade_Passagem: params.qtd_Passagem,
        quantidade_Passagem_Max: params.qtd_PassagemMax,
        vagao_Key: params.vagao_Key,
        molde_Key: params.molde_Key,
        ordem_Serial: params.ordem_Serial,
        molde_Lote: params.molde_Lote,
        molde_Codigo: params.molde_Codigo,
        molde_Descricao: params.molde_Descricao,
        molde_Estoque: params.molde_Estoque,
      };

      if (params.qtd_Passagem === params.qtd_PassagemMax - 1) {
        setOpenModal(true);
        setModelModal(objModal);
      }

      const response = await getMolds();
      if (response) {
        setMoldsSector(response);
      }

      toast.success("Molde atualizado com sucesso", { autoClose: 4000 });
    } catch (error) {
      toast.error("Não foi possível atualizar o molde", { autoClose: 4000 });
      console.error("Erro ao atualizar o molde:", error);
    } finally {
      setLoadingFullScreen(false);
    }
  };

  const getParts = async (sector) => {
    try {
      const { data } = await blogFetch.get(`/SAGAViewPecasSetor/${sector}`);
      setParts(data.sagaViewPecasSetor);
      setOriginalParts(data.sagaViewPecasSetor);
    } catch {
      console.error("Error");
    }
  };

  const postAutomaticPendencia = async (params) => {
    try {
      await blogFetch.post("/ISAGA_Pendencias", params);
    } catch (error) {
      console.error(error);
    }
  };

  const filterGetPartsByFurnace = (parts, triedSerials = new Set()) => {
    const eligible = parts.filter(
      ({ moldIsTrue, pecasSetor, wagonIsTrue }) =>
        moldIsTrue &&
        !wagonIsTrue &&
        !triedSerials.has(pecasSetor?.ordem_Serial) &&
        !(
          pecasSetor?.pend_Key &&
          pecasSetor?.ordem_SetAtual === pecasSetor?.pendMotOrigem_SAPSector
        ),
    );
    if (!eligible.length) return undefined;
    return eligible.sort((a, b) => (parseFloat(b.pecasSetor?.hp) || 0) - (parseFloat(a.pecasSetor?.hp) || 0))[0];
  };

  const postWagon = async (peca, selectedFurnace, status, statusWagon) => {
    setLoadingFullScreen(true);

    try {
      if (
        !status ||
        statusWagon ||
        (peca?.pend_Key &&
          peca?.ordem_SetAtual === peca?.pendMotOrigem_SAPSector)
      ) {
        setLoadingFullScreen(false);
        return;
      }

      const triedSerials = new Set();
      let allNoCombination = true;
      const isNormalFurnace = selectedFurnace?.endsWith('C') || selectedFurnace?.endsWith('H');

      while (triedSerials.size < 20) {
        const piece = filterGetPartsByFurnace(partsByFurnace, triedSerials);
        if (!piece) {
          if (!isNormalFurnace) {
            toast.error(
              (t) => (
                <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  Nenhuma peça elegível encontrada para montar vagão.
                  <button onClick={() => toast.dismiss(t.id)} style={{ marginLeft: 'auto', background: 'none', border: 'none', cursor: 'pointer', fontWeight: 'bold' }}>✕</button>
                </span>
              ),
              { duration: 4000 }
            );
          }
          break;
        }

        const pecaSetor = piece.pecasSetor;

        if (!piece.moldIsTrue || piece.wagonIsTrue) break;

        triedSerials.add(pecaSetor.ordem_Serial);

        const result = await attemptCreateWagon(pecaSetor, selectedFurnace, piece);

        if (result === "ok") return;
        if (result !== "no_combination") allNoCombination = false;
      }

      if (triedSerials.size > 0 && !isNormalFurnace) {
        if (allNoCombination) {
          toast.error(
            (t) => (
              <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                Não há peças suficientes no buffer para montar uma combinação completa neste forno.
                <button onClick={() => toast.dismiss(t.id)} style={{ marginLeft: 'auto', background: 'none', border: 'none', cursor: 'pointer', fontWeight: 'bold' }}>✕</button>
              </span>
            ),
            { duration: 5000 }
          );
        } else if (triedSerials.size >= 20) {
          toast.error(
            (t) => (
              <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                Não foi possível encontrar uma combinação válida após várias tentativas.
                <button onClick={() => toast.dismiss(t.id)} style={{ marginLeft: 'auto', background: 'none', border: 'none', cursor: 'pointer', fontWeight: 'bold' }}>✕</button>
              </span>
            ),
            { duration: 4000 }
          );
        }
      }
    } finally {
      setLoadingFullScreen(false);
    }
  };

  const attemptCreateWagon = async (peca, selectedFurnace, piece) => {
    try {
      const { data } = await blogFetch.post(
        `/ISAGA_CombinacoesPecas/combinations`,
        {
          Ordem_Serial: peca.ordem_Serial,
          Forno: selectedFurnace,
        },
      );
      const isNormalFurnace = selectedFurnace?.endsWith('C') || selectedFurnace?.endsWith('H');
      const apenasCoringa = data.length > 0 && data.every(item => item.tipoCombinacaoPeca?.aproveitamento === 0);
      if (apenasCoringa && !isNormalFurnace) {
        toast(
          (t) => (
            <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              {`⚠️ Atenção: apenas a combinação coringa está disponível. Não foram encontradas combinações específicas para a peça ${peca.ordem_Part_Short} (${peca.ordem_Part_Cod}) — Produto: ${peca.subProduto_Desc}`}
              <button onClick={() => toast.dismiss(t.id)} style={{ marginLeft: 'auto', background: 'none', border: 'none', cursor: 'pointer', fontWeight: 'bold' }}>✕</button>
            </span>
          ),
          { duration: 4000, style: { background: '#FFC107', color: '#000', fontWeight: '500' } }
        );
      }
      await getPartsByFurnace(selectedFurnace, true);
      setWagon(data);
      return "ok";
    } catch (e) {
      const status = e?.response?.status;
      const message = e?.response?.data?.message;
      if (status === 404 && message) {
        return "no_combination";
      }
      console.error("Error: ", e);
      return "error";
    }
  };

  const createAutomaticPendencia = async (pecaSetor) => {
    const params = {
      Pend_Ordem: pecaSetor.ordem_Serial,
      Pend_Status: "ABERTO",
      Pend_Mot_key: 33,
      PendMot_Responsavel: "Produção",
      Pend_Obs: `NÃO FOI POSSÍVEL CRIAR COMBINAÇÃO - Ordem Serial: ${pecaSetor.ordem_Serial} | Produto: ${pecaSetor.subProduto} | Peça: ${pecaSetor.ordem_Part_Cod} | Fórmula ${pecaSetor.formulaCod}`,
    };
    await postAutomaticPendencia(params);
  };

  const getFurnace = async () => {
    try {
      const { data } = await blogFetch.get("/SAGA_Fornos");
      setFurnace(data);
      return data;
    } catch {
      console.error("Error");
    }
  };

  const getPartsByFurnace = async (furnace, internalCall = false) => {
    if (!internalCall) setLoadingFullScreen(true);
    try {
      const { data } = await blogFetch.get(
        `/SAGAViewPecasSetor/Parts?sector=06CURVAD - Buffer&furnace=${furnace}`,
      );
      setPartsByFurnace(data);
      return data;
    } catch {
      console.error("Error");
      return [];
    } finally {
      if (!internalCall) setLoadingFullScreen(false);
    }
  };

  const getMoldesEstoque = async (centro) => {
    try {
      const { data } = await blogFetch.get(
        `SAGAViewPecasSetor/MoldesEstoque?Centro=${centro}`,
      );
      setMoldesEstoque(data);
      return data;
    } catch {
      console.error("Error");
      setMoldesEstoque([]);
    }
  };

  const getConfirmedWagon = async (status, selectedFurnace) => {
    setConfirmedWagon([]);
    setSearchWagon("");
    try {
      setLoading(true);
      setDisableButton(true);
      const { data } = await blogFetch.get(
        `/ISAGA_VagoesFornosPecas?status=${status}&furnace=${selectedFurnace}`,
      );
      const url = data.map((item) => {
        if (item.wagonInfo.vagao_Image)
          item.wagonInfo.vagao_Image +=
            "?sv=2022-11-02&ss=bfqt&srt=sco&sp=rwdlacupiytfx&se=2033-06-06T23:22:22Z&st=2023-06-06T15:22:22Z&spr=https,http&sig=AmNdgNEWKNvsjgz%2BfwYJKb7l1nBWV%2F5V34UqWHQ0n%2FY%3D";
        return item;
      });
      setConfirmedWagon(url);
    } catch {
      console.error("Error");
    } finally {
      setDisableButton(false);
      setLoading(false);
    }
  };

  const getHourByFurnace = async (furnace, status) => {
    try {
      const arrPromise = furnace.map(async (item) => ({
        forno: item.forno_Name,
        data: await fetchHourByFurnaceCached(status, item.forno_Name),
      }));
      const response = await Promise.all(arrPromise);
      return response;
    } catch (error) {
      toast.error("Não foi possível carregar status do Fornos!", {
        duration: 4000,
      });
      return [];
    }
  };

  const getSimilarParts = async (params) => {
    setLoading(true);
    try {
      const { data } = await blogFetch.get(
        `/ISAGA_SimilarParts?ordem=${params.ordem}`,
      );
      setSimilarParts(data);
      setLoading(false);
    } catch (e) {
      console.error(e);
      setLoading(false);
    }
  };

  const getFornosHitorico = async (params) => {
    const myReq = ++fichaReqSeq.current;
    setLoadingFicha(true);
    try {
      const { data } = await blogFetch.get(
        `/ISAGA_VagoesFornos/getForno?ordem=${params.ordem}`,
      );
      if (myReq !== fichaReqSeq.current) return;
      setFornoObj(data);
    } catch (error) {
      console.error(error);
    } finally {
      if (myReq === fichaReqSeq.current) setLoadingFicha(false);
    }
  };

  const state = {
    setLoading,
    loading,
    displayMenu,
    setDisplayMenu,
    displayIcon,
    setDisplayIcon,
    getStatusSideBar,
    selectedValueSector,
    setSelectedValueSector,
    getSector,
    loadingFicha,
    setLoadingFicha,
    getPartFlow,
    idStep,
    setIdStep,
    partFlowObj,
    setPartFlowObj,
    handleInfo,
    infoLoading,
    getPecas,
    getGlassLot,
    getGlassComponent,
    saga_Componentes,
    setSaga_Componentes,
    getMoldes,
    getToolMasurementsObj,
    getMaterialForm,
    pecasObj,
    setPecasObj,
    rastreabilidadeObj,
    setRastreabilidadeObj,
    getRastreabilidade,
    glassLotObj,
    setGlassLotObj,
    moldesObj,
    setmoldesObj,
    toolMasurementsObj,
    setToolMasurementsObj,
    materialFormObj,
    setMaterialFormObj,
    codeMaterials,
    setCodeMaterials,
    getBuffers,
    bufferObj,
    setBufferObj,
    getSalesOrdersBI,
    SalesOrdersObj,
    setSalesOrdersObj,
    showmodalIMG,
    setShowmodalIMG,
    toolTipText,
    setToolTipText,
    statusPendencia,
    setStatusPendencia,
    showModalFicha,
    setShowModalFicha,
    selectedCountry,
    setSelectedCountry,
    infoPiece,
    setInfoPiece,
    code,
    setCode,
    getFicha,
    loadingIndustryPartsTable,
    setIndustryPartsTable,
    getMolds,
    putMold,
    getChangeMolds,
    moldsSector,
    setMoldsSector,
    wagon,
    postWagon,
    setWagon,
    parts,
    setParts,
    getParts,
    originalParts,
    setOriginalParts,
    furnace,
    setFurnace,
    getFurnace,
    selectedFurnace,
    setSelectedFurnace,
    setPartsByFurnace,
    partsByFurnace,
    getPartsByFurnace,
    setConfirmedWagon,
    confirmedWagon,
    getConfirmedWagon,
    loadingWagonTable,
    setLoadingWagonTable,
    setLoadingFullScreen,
    loadingFullScreen,
    setSelectedWagon,
    selectedWagon,
    getHourByFurnace,
    getSimilarParts,
    similarParts,
    setDisableButton,
    disableButton,
    moldesEstoque,
    setMoldesEstoque,
    getMoldesEstoque,
    setSearchWagon,
    searchWagon,
    setItemsPriority,
    itemsPriority,
    setInputValue,
    inputValue,
    status,
    setStatus,
    getFornosHitorico,
    fornoObj,
    openModal,
    setOpenModal,
    modelModal,
  };

  return <Context.Provider value={state}>{children}</Context.Provider>;
}
